<script lang="ts">
    
    import IconTarget from "./IconTarget.svelte";

    export let size = 30;

</script>

<div class="is-target" style="--size: {size}px;">
    <IconTarget color="#fff" size={size * 0.75} />
</div>

<style lang="scss">

    .is-target {
        width: var(--size);
        height: var(--size);
        background-color: var(--color-primary);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

</style>
